import { render, staticRenderFns } from "./trainRequest.vue?vue&type=template&id=fece1886&scoped=true&"
import script from "./trainRequest.vue?vue&type=script&lang=ts&"
export * from "./trainRequest.vue?vue&type=script&lang=ts&"
import style0 from "./trainRequest.vue?vue&type=style&index=0&id=fece1886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fece1886",
  null
  
)

export default component.exports